import axios from "@/libs/axios";

const endpointPrefix = process.env.VUE_APP_API_PREFIX;

export default {
  getData() {
    return axios.get(`/${endpointPrefix}/dashboard`)
  },
}
